import { Flex, Text, Tooltip } from '@radix-ui/themes'
import { DataTestIDs } from 'shared/constants'
import { DemoCoinIcon, formatDemoAmount } from 'shared/ui/demo-amount'
import { DEMO_COIN_BALANCE_LABEL } from '../constants'
import { useDemoCoinBalance } from '../hooks/use-demo-coin-balance'
import { useDemoCoinBalanceRefresh } from '../hooks/use-demo-coin-balance-refresh'

/**
 * The signed-in player's demo coins in the header, where the USDT balance is
 * on the on-chain stand; nothing for a guest or with `offchainOnly` off. On
 * every page of the off-chain stand, so it keeps every reader of the balance
 * fresh (`useDemoCoinBalanceRefresh`).
 */
export const HeaderDemoCoinBalance = () => {
  const coins = useDemoCoinBalance()
  const { isEnabled, balance } = coins

  useDemoCoinBalanceRefresh(coins)

  if (!isEnabled) return null

  return (
    <Tooltip content='Staked in the demo games. Winnings add coins back.'>
      <Flex direction={'column'}>
        <Text
          size={'1'}
          className={'color-white'}
          weight={'medium'}
        >
          {DEMO_COIN_BALANCE_LABEL}
        </Text>

        <Flex
          align={'center'}
          gap={'1'}
        >
          <DemoCoinIcon
            size='2.5rem'
            className='color-yellow'
          />

          <Text
            className='color-white'
            data-testid={DataTestIDs.headerDemoCoinBalance}
          >
            {balance === null ? '---' : formatDemoAmount(balance)}
          </Text>
        </Flex>
      </Flex>
    </Tooltip>
  )
}
